<template>
    <div class="d-flex ai-center gap-8 pos-r">
        <template v-if="list && selectedItem">
            Статус: <v-status :type="status.color" :text="status.text" />
            <v-button
                tabindex="-1" class="custom-select__button button_type_static" 
                :disabled="disabled || isloading"
                @click.stop.prevent="handlButtonClick"
            >
                <svg aria-hidden="true" width="16" height="16">
                    <use href="#icon-angle-down"></use>
                </svg>
            </v-button>
            <v-list v-if="list"
                ref="list"
                class="dropList_size_full-width"
                :list="list" 
                :expand="expand"
                :selected="selectedItem"
                @click="handleClickList($event)
            "/>
        </template>
        <template v-else>
            <v-preloader size="small"/>
        </template>
    </div>
</template>

<script>
import api from '@api'
import vStatus from '@components/global/Status.vue'
import vButton from '@components/global/vButton.vue'
import vList from '@components/global/DropDownList'
import vPreloader from '@components/global/Preloader'

export default {
    name: 'vStatusSwitcher',
    components: {
        vStatus,
        vButton,
        vList,
        vPreloader
    },
    data() {
        return {
            isFocus: false,
            isloading: false,
            disabled: false,
            lisStatus: null,
            selectedItem: false,
            list: null,
            expand: false,
            status: false
        }
    },
    mounted() {
        this.getList()
        this.getStatus()
    },
    methods: {
        handleClickList(e) {
            this.expand = false
            if(this.disabled) return
            if(this.selectedItem.id === e.id) return
            this.selectedItem = e
            this.setStatus(e.id).then(() => {
                this.getStatus()
            })
        },
        handlButtonClick() {
            this.expand = !this.expand
        },
        getList() {
            this.isloading = true
            api.tel.listStatus().then(res => {
                this.list = res
            }).catch(error=>{
                if(error.message) this.$toast.error(error.message)
                console.error(error)
            }).finally(e=>{
                this.isloading = false
            })
        },
        setStatus(status) {
            this.isloading = true
            this.disabled = true
            return api.tel.setStatus({status}, '', 'post').then(res => {
                this.$toast.success(res.message)
            }).catch(error=>{
                if(error.message) this.$toast.error(error.message)
                console.error(error)
            }).finally(e=>{
                this.isloading = false
                this.disabled = false
            })
        },
        getStatus() {
            this.isloading = true
            api.tel.getStatus().then(res => {
                const {color,id,text} = res
                this.selectedItem = {id, name:text}
                this.status = {color,text}
            }).catch(error=>{
                if(error.message) this.$toast.error(error.message)
                console.error(error)
            }).finally(e=>{
                this.isloading = false
            })
        }
    }
}
</script>